// extracted by mini-css-extract-plugin
export var content = "index-module--content--+X+Cu";
export var schoolCol = "index-module--school-col--aRQmp";
export var programColLeft = "index-module--program-col-left--Oc1Bf";
export var buttonColRight = "index-module--button-col-right--24khA";
export var displayLinebreaks = "index-module--display-linebreaks--pR3-s";